import { z } from 'zod';
/**
 * Conversation — a chat thread with multiple messages, owned by a device.
 */
export const ConversationSchema = z.object({
    id: z.string(),
    deviceId: z.string(),
    title: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/**
 * Conversation summary — lightweight listing with last message preview.
 */
export const ConversationSummarySchema = z.object({
    id: z.string(),
    title: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    lastMessage: z.string().optional(),
    messageCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=conversation.js.map